import { render, staticRenderFns } from "./SellLand.vue?vue&type=template&id=e4716228&scoped=true&"
import script from "./SellLand.vue?vue&type=script&lang=js&"
export * from "./SellLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4716228",
  null
  
)

export default component.exports